import { useVideoPlayerRefs } from "../../contexts/VideoPlayerRefs";
import { usePeripheralEvents } from "../../hooks/usePeripheralEvents";
import { Poster } from "../Poster";
import { VideoElement } from "../VideoElement";
import { ControlBar } from "../ControlBar";
import { LoadingIndicator } from "../LoadingIndicator";

import styles from "./styles.module.css";
import { useRoot } from "../../contexts/Root";
import { SoloSeekBar } from "../SoloSeekBar";
import { Controls } from "../..";

export interface BaseProps {
  listenKeyboard?: boolean;
  listenPointer?: boolean;
  children?: React.ReactNode;
}

export const BaseVideoPlayer = ({
  listenKeyboard = false,
  listenPointer = true,
}: BaseProps) => {
  const { container } = useVideoPlayerRefs();
  const { controls } = useRoot();

  usePeripheralEvents(listenKeyboard, listenPointer);

  const showSoloSeekBar = controls === Controls.nonInteractiveSeekBar;
  const showControlBar =
    controls === Controls.fullControlBar ||
    controls === Controls.partialControlBar;

  return (
    <div className={styles.container} ref={container}>
      {showSoloSeekBar && <SoloSeekBar />}
      {showControlBar && <ControlBar />}
      <LoadingIndicator />
      <VideoElement />
      <Poster />
    </div>
  );
};
